import React from "react"
import "./get-points-for.scss"

/* Import Images */
// import DevolverEmpaques from '../../../assets/images/devolver-empaques.svg'
import PublicarContenido from "../../../assets/images/publicar-contenido.svg"
// import cumpleanos from '../../../assets/images/cumpleanos.svg'
// import TenerReferidos from '../../../assets/images/tener-referidos.svg'
import RegistrarClaves from "../../../assets/images/registrar-claves.svg"
import Bienvenida from "../../../assets/images/bienvenida.svg"
import Aniversario from "../../../assets/images/aniversario.svg"
import Empaques from "../../../assets/images/empauqes.png"

import GenericModal from "../../../shared/components/modals/generic-modal/generic-modal"
import { getTextPointsForPostContent, getTextPointsForRegisterKeys, getTextPointsForYourAnniversary, getTextPointsForYourWelcome, getTitlePointsFor } from "../../../utils/getPointMessages"

const GetPointsFor = props => {

  return (
    <GenericModal>
      <span
        onClick={props.setModalClose}
        className="icon2-close f-icon f-icon-close-modal"
      />
      <div className="f-get-points-for-container">
        <div className="f-get-points-for-container-title">
          <h1>{getTitlePointsFor(process.env.LOCALE)}</h1>
        </div>
        <div className="f-get-points-for-container-points">
          {/* <div className="f-get-points-for-container-points-items">
                        <img src={DevolverEmpaques} alt="Devolver los empaques" />
                        <p>Devolver <br /> los empaques</p>
                    </div> */}
          {
            process.env.LOCALE != "es-CL" ? 
          <div className="f-get-points-for-container-points-items">
            <div className="f-get-points-container">
              <img src={PublicarContenido} alt="Publicar contenido" />
            </div>

                <p className="f-get-points-title">
                Publicar contenido:{" "}
                  <span className="f-get-points-description">
                  {getTextPointsForPostContent(process.env.LOCALE)}
                  </span>
                </p>
          </div>
            : ''
          }
          <div className="f-get-points-for-container-points-items">
            <div className="f-get-points-container">
              <img
                src={RegistrarClaves}
                alt="Registrar claves por primera vez"
              />
            </div>
            <p className="f-get-points-title">
              Registrar claves por primera vez:{" "}
              <span className="f-get-points-description">
                {getTextPointsForRegisterKeys(process.env.LOCALE)}
              </span>
            </p>
          </div>
          {/* {process.env.LOCALE === 'es-EC' && <div className="f-get-points-for-container-points-items">
            <div className="f-get-points-container">
              <img src={cumpleanos} alt="Cumpleaños" />
            </div>
            <p className="f-get-points-title">
              Feliz cumpleaños:{" "}
              <span className="f-get-points-description">
                Feliz cumpleañosFeliz cumpleañosFeliz cumpleañosFeliz cumpleañosFeliz cumpleañosFeliz cumpleañosFeliz cumpleañosFeliz cumpleañosFeliz cumpleañosFeliz cumpleañosFeliz cumpleañosFeliz cumpleañosFeliz cumpleaños
              </span>
            </p>
          </div>} */}
          <div className="f-get-points-for-container-points-items">
            <div className="f-get-points-container">
              <img src={Bienvenida} alt="Por tu bienvenida" />
            </div>
            <p className="f-get-points-title">
              Por tu bienvenida:{" "}
              <span className="f-get-points-description">
                {getTextPointsForYourWelcome(process.env.LOCALE)}
              </span>
            </p>
          </div>
          <div className="f-get-points-for-container-points-items">
            <div className="f-get-points-container">
              <img src={Aniversario} alt="Por tu aniversario" />
            </div>
            <p className="f-get-points-title">
              Por tu aniversario:{" "}
              <span className="f-get-points-description">
                {getTextPointsForYourAnniversary(process.env.LOCALE)}
              </span>
            </p>
          </div>

          {process.env.LOCALE === "es-CO" && (
            <div className="f-get-points-for-container-points-items">
              <div className="f-get-points-container">
                <img src={Empaques} alt="Por tu aniversario" />
              </div>
              <p className="f-get-points-title">
                Por tus empaques:{" "}
                <span className="f-get-points-description">
                  cuando lleves a los Servientrega autorizados, un sobre marcado con tus datos con 10 empaques Nosotras para
                  reciclar, recibirás 20 puntos por ayudarnos a darle Loving al planeta. Además por cada empaque adicional
                  que envíes, ganas 2 puntos. Recuerda que estos serán adicionados a tu banco de puntos aproximadamente 20 días
                  después de haber enviado tu sobre <a href="https://www.nosotrasonline.com.co/mis-puntos/entrega-empaques/" target="_blank">Descubre más aquí</a>.
              </span>
              </p>
            </div>
          )}

        </div>
      </div>
    </GenericModal>
  )
}

export default GetPointsFor
